import React from 'react'
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faFacebookF } from '@fortawesome/free-brands-svg-icons'
import {  faTwitter } from '@fortawesome/free-brands-svg-icons'
import {  faYoutube } from '@fortawesome/free-brands-svg-icons'
import {  faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import {  faInstagram } from '@fortawesome/free-brands-svg-icons'
import {  faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import {  faPhoneFlip } from '@fortawesome/free-solid-svg-icons'


function Header(){
    return(
        <div className='header'>   
           <div className='contact'>
            <a href=''><FontAwesomeIcon icon={faPhoneFlip} /><span>Have any question? +91 9947144333</span></a>
           </div>
           <div className='social'>
            <div className='icons'>
                    <ul>
                        <li> <a href=''> <FontAwesomeIcon icon={faFacebookF} /></a></li>
                        <li><a href=''> <FontAwesomeIcon icon={faTwitter} /></a></li>
                        <li><a href=''> <FontAwesomeIcon icon={faYoutube} /></a></li>
                        <li><a href=''> <FontAwesomeIcon icon={faLinkedinIn} /></a></li>
                        <li> <a href=''> <FontAwesomeIcon icon={faInstagram}  /></a></li>
                        <li> <a href=''> <FontAwesomeIcon icon={faWhatsapp} /></a></li>
                    </ul>
            </div>
            <div className='training'>
                <a href=''>Book Corporate Training</a>
            </div>   
           </div>
        </div>
    )

}
export default Header;